import { render } from "./process-icon.vue?vue&type=template&id=efff6ac4&scoped=true"
import script from "./process-icon.vue?vue&type=script&lang=js"
export * from "./process-icon.vue?vue&type=script&lang=js"

import "./process-icon.vue?vue&type=style&index=0&id=efff6ac4&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efff6ac4"]])

export default __exports__